import { ReactNode } from "react";

export interface Crumb {
  label: string;
  /** Omit on the final crumb to render it as the current page. */
  onClick?: () => void;
}

interface ReportPageHeaderProps {
  /** Omit on tab pages, where the tab group already names the page. */
  crumbs?: Crumb[];
  /** Right-aligned content, e.g. a region picker or an action button. */
  actions?: ReactNode;
}

const ReportPageHeader = ({ crumbs, actions }: ReportPageHeaderProps) => (
  <div className="admin-report__header">
    {crumbs && crumbs.length > 0 && (
      <nav aria-label="Breadcrumb" className="admin-report__crumbs">
        {crumbs.map(({ label, onClick }, index) => (
          <span key={label} className="admin-report__crumb">
            {index > 0 && (
              <span
                aria-hidden="true"
                className="admin-report__crumb-separator"
              >
                ›
              </span>
            )}
            {onClick ? (
              <button
                type="button"
                className="admin-report__crumb-link"
                onClick={onClick}
              >
                {label}
              </button>
            ) : (
              <span aria-current="page" className="admin-report__crumb-current">
                {label}
              </span>
            )}
          </span>
        ))}
      </nav>
    )}
    {actions && <div className="admin-report__header-actions">{actions}</div>}
  </div>
);

export default ReportPageHeader;
